<template>
  <ion-header class="rp-mobile">
    <ion-toolbar class="mobile-header-toolbar">
      <ion-buttons v-slot: start>
        <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
        <ion-title class="fontRoboto">Select Charger</ion-title>
        <ion-icon :icon="homeSharp"  class="ion-margin ios-home" @click="homePage"></ion-icon>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-header class="rp-desktop">
    <ion-toolbar class="header-toolbar">
      <ion-grid class="title-wrapper ion-no-padding">
        <ion-row>
          <ion-col size-md="8">
            <ion-toolbar class="mobile-header-toolbar">
              <ion-buttons v-slot: start>
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
              </ion-buttons>
              <ion-title class="fontRoboto">New Reservation/Select Charger</ion-title>
            </ion-toolbar>
          </ion-col>
          <ion-col size-md="4" size-xs="8" class="ion-no-padding">
            <div class="price-tag">
              <p class="ion-no-margin">Available Bal</p>
              <p class="ion-no-margin">&#8377; {{this.amountDetails.clearBalance}}</p>
            </div>
            <div class="price-tag">
              <p class="ion-no-margin">Current Bal</p>
              <p class="ion-no-margin">&#8377; {{this.amountDetails.totalBalance}}</p>
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-toolbar>
  </ion-header>
  <ion-content class="book-page">
    <div class="page-wrapper">
      <div class="container" v-if="showUpdateCard">
        <div class="card">
          <h4>Update Required</h4>
          <p>Update Your Profile and My EVs</p>
          <div class="btn-group">
            <ion-button class="btn-res" expand="block" @click="updateProfile">Add Profile</ion-button>
            <ion-button class="btn-res" expand="block" @click="addEV">Add EVs</ion-button>
          </div>
        </div>
      </div>
      <div class="container" v-else-if="showProfileCard && !showUpdateCard">
        <div class="card">
          <h4>Update Profile</h4>
          <p>Update Your Profile with Email Address and State Details</p>

          <ion-button
            class="btn-res"
            expand="block"
            @click="updateProfile"
          >
            Add Profile
          </ion-button>
        </div>
      </div>

      <div class="container" v-else-if="showEvCard && !showUpdateCard">
        <div class="card">
          <h4>Add My EVs</h4>
          <p>Add Your Evs in My E-Vehicle</p>

          <ion-button
            class="btn-res"
            expand="block"
            @click="addEV"
          >
            Add EVs
          </ion-button>
        </div>
      </div>
      <div v-if="selectedMarker.name != ''">
        <div class="title-add-wrapper">
          <ion-grid>
            <ion-row>
              <ion-col size-md="10" size-xs="9">
                <p class="ion-no-margin fontRobotoBold title">{{selectedMarker.name}}<span v-if="selectedMarker.rating != 0">&nbsp; {{selectedMarker.rating}}&nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></p>
                <p class="ion-no-margin fontRoboto subtitle">
                  {{selectedMarker.address.line1}},
                  {{selectedMarker.address.city}}
                </p>
              </ion-col>
              <ion-col size-md="2" size-xs="3">
                <a class="call-img-a ion-text-end" v-bind:href="teleUrl">
                  <img class="call-img ion-float-end" src="../../assets/card-call.png" />
                </a>
              </ion-col>
            </ion-row>
            <ion-row class="add-wrapper">
              <ion-col size-md="10" size-xs="8">
                <img class="loc-img" src="/assets/images/station/117967-1.png" />
                <div class="add-sec">
                  <p class="ion-no-margin fontRoboto address">
                    {{selectedMarker.address.line1}},
                    {{selectedMarker.address.city}}, {{selectedMarker.address.state.name}} -
                    {{selectedMarker.address.zipcode}}
                  </p>
                  <p class="ion-no-margin fontRobotoLight timeArea"  v-if="!thirdPartyInd">
                    <span>Today :</span>
                    {{opensAt}} -
                    {{closesAt}}
                  </p>
                </div>
                <div class="clearFix"></div>
              </ion-col>
              <ion-col size-md="2" size-xs="4">
                <p class="ion-no-margin distance ion-text-end">{{selectedMarker.distance.description}}</p>
                <img
                  @click="googleMapApp()"
                  class="map-img ion-float-end"
                  src="../../assets/card-map.png"
                />
              </ion-col>
            </ion-row>
            
          </ion-grid>
        </div>
        <div class="rectangle" v-if="thirdPartyInd">
          <ion-grid>
            <ion-row v-for="(item, index) in this.thirdPartyInfo" :key="index">
              <!-- <ion-col size-md="3" size-xs="12">
                <p>{{item.thirdPartyName}}</p>
              </ion-col> -->
              <ion-col size-md="9" size-xs="6" class="ion-margin-top">
                <p class="ion-no-margin  title" v-html="item.descriptions"></p>
              </ion-col>
              <ion-col size-md="3" size-xs="6" class="ion-margin-top ion-margin-top">
                <img :src="thirdPartImgURL+item.imgUrl" class="thirdparty-img">              
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <div class="rectangle" v-if="displayCaptiveInfo">
          <ion-grid>
            <ion-row v-for="(item, index) in this.thirdPartyInfo" :key="index">
              <ion-col size-md="12" size-xs="12" class="ion-margin-top">
                <p class="ion-no-margin  title" v-html="item.descriptions"></p>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        <br  v-if="thirdPartyInd">
        <div class="Charging-station-list">
          <p class="ion-no-margin fontRobotoBold title">Select Charger</p>
          <div class="spinnerWrapper">
            <ion-spinner v-if="loaderTab"></ion-spinner>
          </div>
          <ion-grid v-if="chargeNowInd">
            <br>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="paddingGrid" v-for="(item, index) in stationArray"
                :key="index"
                v-bind:class="{ inactiveWrapper: item.port.status.id == 'I' || item.port.status.id == 'UN'}">
              <ion-col
                size-md="12"
                size-sm="12"
                size-xs="12"
                size-lg="12"
                size-xl="4"
                class="listGrid paddingZero paddingRight"
                v-if="item.port.id == portId && item.outlet.output.number == outputNumber && chargeNowInd"
              >
              <!-- 08-09-2021 Below code is modified by vinoth as per CR SCMT-CMS Charger Availability Status from row size 10 to 9.5 and 2 to 2.5 -->
                <ion-row class="cs-grid">
                  <ion-col size-md="9.5" size-sm="9.5" size-xs="9.5">
                    <img class="cs-grid-img" :src="item.image" />
                    <div class="cs-grid-cont">
                      <!-- Below code is commented for title is trimed so hereafter no need to trim the title -->
                      <!-- <p class="ion-no-margin fontRobotoBold">{{getTitle(item.title)}}</p> -->

                      <p class="ion-no-margin fontRobotoBold">{{item.titleGroup}}</p>
                      <!-- Below code is commented on 08-05-2025, for no need to display subtitle and details of the charger -->
                      <!-- <p class="ion-no-margin fontRoboto">{{item.subTitle}}</p> -->
                      <!-- <p class="ion-no-margin fontRoboto">{{item.detail}}, <br>{{item.bayDetails.bayName}}, {{item.bayDetails.connectorName}}</p>  -->
                      <p class="ion-no-margin fontRoboto">{{item.bayDetails.bayName}}, {{item.bayDetails.connectorName}}</p>
                      <p class="ion-no-margin fontRoboto" v-if="!thirdPartyInd">Tariff : ₹ {{item.rate.amount}}{{item.rate.unit.unit}}</p>
                    </div>
                  </ion-col>
                  <ion-col size-md="2.5" size-sm="2.5" size-xs="2.5" class="ion-no-padding" v-if="!thirdPartyInd">
                    <ion-checkbox
                      class="cs-grid-status-img"
                      :key="item.isChecked"
                      v-if="item.isChecked && item.port.status.id != 'UN'"
                      checked="true"
                      @click="selecChargerUpdate(index, stationArray, item,item.isChecked)"
                    ></ion-checkbox>
                    <ion-checkbox
                      class="cs-grid-status-img"
                      :key="item.isChecked"
                      v-if="!item.isChecked && item.port.status.id != 'UN' && !displayCaptiveInfo"
                      :checked='(item.port.id == portId && item.outlet.output.number == outputNumber && chargeNowInd) ? selecChargerUpdate(index, stationArray, item,item.isChecked) : "false"'
                      @click="selecChargerUpdate(index, stationArray, item,item.isChecked)"
                    ></ion-checkbox>
                    <p
                      class="ion-no-margin cs-grid-status"
                      v-if="item.port.status.id == 'A' && !displayCaptiveInfo"
                    >{{item.port.status.name}}</p>
                    <p
                      class="ion-no-margin cs-grid-status inactive"
                      v-if="item.port.status.id == 'I' && !displayCaptiveInfo"
                    >{{item.port.status.name}}</p>
                    <!-- 08-09-2021 Below code is added by vinoth as per CR SCMT-CMS Charger Availability Status -->
                    <p
                      class="ion-no-margin cs-grid-status unavailable"
                      v-if="item.port.status.id == 'UN' && !displayCaptiveInfo"
                    >{{item.port.status.name}}</p>
                    <p
                      class="ion-no-margin cs-grid-status occupied"
                      v-if="item.port.status.id == 'OC' && !displayCaptiveInfo"
                    >{{item.port.status.name}}</p>
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </ion-grid>
          
          <!-- Below code is general reservation -->
          <ion-grid v-if="!chargeNowInd">
            <ion-row class="paddingGrid">
              <ion-col
                size-md="12"
                size-sm="12"
                size-xs="12"
                size-lg="12"
                size-xl="4"
                class="listGrid paddingZero paddingRight"
                v-for="(item, index) in stationArray"
                :key="index"
                v-bind:class="{ inactiveWrapper: item.port.status.id == 'I' || item.port.status.id == 'UN'}"
              >
              <!-- 08-09-2021 Below code is modified by vinoth as per CR SCMT-CMS Charger Availability Status from row size 10 to 9.5 and 2 to 2.5 -->
                <ion-row class="cs-grid">
                  <ion-col size-md="9.5" size-sm="9.5" size-xs="9.5">
                    <img class="cs-grid-img" :src="item.image" />
                    <div class="cs-grid-cont">
                      <!-- Below code is commented on 08-05-2025 for title is trimed so hereafter no need to trim the title -->
                      <!-- <p class="ion-no-margin fontRobotoBold">{{getTitle(item.title)}}</p> -->
                      <p class="ion-no-margin fontRobotoBold">{{item.titleGroup}}</p>
                      <!-- Below code is commented on 08-05-2025, for no need to display subtitle and details of the charger -->
                      <!-- <p class="ion-no-margin fontRoboto">{{item.subTitle}}</p>
                      <p class="ion-no-margin fontRoboto">{{item.detail}}, <br>{{item.bayDetails.bayName}}, {{item.bayDetails.connectorName}}</p> -->
                      <p class="ion-no-margin fontRoboto">{{item.bayDetails.bayName}}, {{item.bayDetails.connectorName}}</p>
                      <p class="ion-no-margin fontRoboto" v-if="!thirdPartyInd">Tariff : ₹ {{item.rate.amount}}{{item.rate.unit.unit}}</p>
                      <!-- <p class="ion-no-margin fontRoboto"> Bay-1</p> -->
                      <!-- <p class="ion-no-margin fontRoboto"> Port-1</p> -->
                    </div>
                  </ion-col>
                  <ion-col size-md="2.5" size-sm="2.5" size-xs="2.5" class="ion-no-padding" v-if="!thirdPartyInd && !displayCaptiveInfo">
                    <ion-checkbox
                      class="cs-grid-status-img"
                      :key="item.isChecked"
                      v-if="item.isChecked && item.port.status.id != 'UN'"
                      checked="true"
                      @click="selecChargerUpdate(index, stationArray, item,item.isChecked)"
                    ></ion-checkbox>
                    <ion-checkbox
                      class="cs-grid-status-img"
                      :key="item.isChecked"
                      v-if="!item.isChecked && item.port.status.id != 'UN'"
                      :checked='(item.port.id == portId && chargeNowInd) ? selecChargerUpdate(index, stationArray, item,item.isChecked) : "false"'
                      @click="selecChargerUpdate(index, stationArray, item,item.isChecked)"
                    ></ion-checkbox>
                    <p
                      class="ion-no-margin cs-grid-status"
                      v-if="item.port.status.id == 'A'"
                    >{{item.port.status.name}}</p>
                    <p
                      class="ion-no-margin cs-grid-status inactive"
                      v-if="item.port.status.id == 'I'"
                    >{{item.port.status.name}}</p>
                    <!-- 08-09-2021 Below code is added by vinoth as per CR SCMT-CMS Charger Availability Status -->
                    <p
                      class="ion-no-margin cs-grid-status unavailable"
                      v-if="item.port.status.id == 'UN'"
                    >{{item.port.status.name}}</p>
                    <p
                      class="ion-no-margin cs-grid-status occupied"
                      v-if="item.port.status.id == 'OC'"
                    >{{item.port.status.name}}</p>
                  </ion-col>
                </ion-row>
                
              </ion-col>
            </ion-row>
          </ion-grid>
          <p class="show-more-link fontRobotoBold" v-if="dataFound">No Data Found</p>
        </div>
        <div class="time-detail-wrapper" v-if="!thirdPartyInd">
          <div class="time-detail-list time-details">
            <img class="td-list-img clock" src="/assets/images/station/149313.png" />
            <div class="td-list-cont">
            <p class="ion-no-margin fontRobotoLight"><b>Station Working hours</b></p>
            
              <!-- p class="ion-no-margin fontRoboto timeArea">
                <span>Today:</span>
                {{opensAt}} - {{closesAt}}
              </p -->
              <p
                class="ion-no-margin fontRobotoLight"
                :key="index"
                v-for="(item, index) in this.hoursOfOperations"
              >{{item.day}}: {{item.openAt}} - {{item.closeAt}}</p>
              <br />
              <p v-if="this.holidaysList && this.holidaysList.length > 0" class="ion-no-margin fontRobotoLight"><b>Public Holidays</b></p>
              <p
                class="ion-no-margin fontRobotoLight"
                :key="hindex"
                v-for="(item, hindex) in this.holidaysList"
              >{{ changeDateFormatWithoutTime(item.date) }} - {{item.reason}} - {{item.timing}}</p>
            </div>
          </div>
          <div class="time-detail-list phone-num">
            <img class="td-list-img call" src="/assets/images/station/1034131.png" />
            <div class="td-list-cont colorUP">
              <p class="ion-no-margin fontRoboto">
                <a v-bind:href="'tel:'+selectedMarker.mobile">{{selectedMarker.mobile}}</a>
              </p>
              <p class="ion-no-margin fontRoboto">
                <a v-bind:href="'tel:'+selectedMarker.landline">{{selectedMarker.landline}}</a>
              </p>
            </div>
          </div>
          <div class="time-detail-list email">
            <img class="td-list-img envalop" src="/assets/images/station/1034138.png" />
            <div class="td-list-cont colorUP">
              <p class="ion-no-margin fontRoboto">{{selectedMarker.email}}</p>
            </div>
          </div>
        </div>
        <div class="Charging-station-list" v-if="!thirdPartyInd">
          <ion-slides v-if="this.stationImages && this.stationImages.length > 0"  pager="true" :options="slideOpts">
            <ion-slide class="ion-text-center" 
              :key="hindex"
              v-for="(item, hindex) in this.stationImages"
            >
              <div>
                <img :src="item.file" />
              </div>
            </ion-slide>
          </ion-slides>
        </div>
      </div>
    </div>
  </ion-content>
  <ion-footer>
    <ion-button
      expand="full"
      @click="slotBooking()"
      v-bind:disabled="selectedChargerValue == null"
      class="next-btn fontRobotoMedium" v-if="!thirdPartyInd && !displayCaptiveInfo"
    >
      Next
      <img src="/assets/images/station/109617.png" />
    </ion-button>
  </ion-footer>
</template>

<script>
import { IonHeader, IonFooter, IonToolbar, IonButtons, IonBackButton, IonButton, IonTitle, IonContent, IonIcon, IonGrid, IonRow, IonCol, IonCheckbox, IonSpinner, IonSlides, IonSlide, alertController } from "@ionic/vue";
import { defineComponent } from "vue"
import { Coordiate } from "@/entity/location/corodinate";
import { EVCStationService } from "@/service/evcstation/stations.service";
import { LocalStorage } from "../../data/localstorage";
import { WalletService } from "@/service/wallet/wallet.service";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { flag, flash, homeSharp, star } from 'ionicons/icons';
import { EVCStationReservationService } from "@/service/evcstation/reservation.service";
import moment from "moment";
import { VehicleService } from "../../service/vehicle/vehicle.service";
import { config } from "../../config";

export default defineComponent ({
name: 'bookNow',
components: {
  IonHeader, 
  IonFooter, 
  IonToolbar, 
  IonButtons, 
  IonBackButton, 
  IonTitle, 
  IonContent, 
  IonIcon, 
  IonGrid, 
  IonRow, 
  IonCol, 
  IonCheckbox, 
  IonSpinner,
  IonButton,
  IonSlides, 
  IonSlide,
  alertController
},
data() {
  return {
    homeSharp,
    star,
    displayInd: false,
    slideOpts :{
      initialSlide : 1,
      speed: 400,
      autoplay: true,
      loop: true
    },
    stationArray: [],
    stationImages : [],
    showMore: false,
    dataFound: false,
    stationArrayLength: null,
    teleUrl: "",
    selectedMarker: {
      name: "",
      distance: { description: "" },
      address: {
        city: "",
        line1: "",
        state: { name: "" }
      }
    },
    opensAt: "",
    closesAt: "",
    amountDetails: {
      totalBalance: "",
      clearBalance: ""
    },
    loaderTab: true,
    selectedChargerValue: null,
    hoursOfOperations: [],
    holidaysList: [],
    stationMasterArray: null,
    thirdPartyInfo: "",
    thirdPartyInd: false,
    innerHt: "<b>hi hello<b>",
    chargeNowInd: false,
    portId: "",
    messageDisplayCount: 0,
    thirdPartImgURL: "",
    displayCaptiveInfo: false,
    showUpdateCard: false,
    showProfileCard: false,
    showEvCard: false
  }
},
async mounted() {
  let userProfile = JSON.parse(localStorage.getItem('user.profile') || '{}');
  let stateCode = userProfile?.address?.state?.code;

  let user = new LocalStorage().user;
  let vehicles = await new VehicleService().vehiclesOfUser(user);

  const hasProfile = !!stateCode;
  const hasVehicles = vehicles && vehicles.length > 0;

  this.showUpdateCard = !hasProfile && !hasVehicles;

  this.showProfileCard = !hasProfile;

  this.showEvCard = !hasVehicles;

  if(hasProfile && hasVehicles) {
    await this.chargerDetails()
  }

},
methods: {
  async chargerDetails() {
    try {
    this.thirdPartImgURL = config.api.host
    localStorage.removeItem("duration");
    this.teleUrl = localStorage.getItem("teleUrl");
    this.selectedMarker = JSON.parse(localStorage.getItem("selectedMarker"));
    let chargeNow = localStorage.getItem('chargeNow');
    if(chargeNow != null) {
      this.chargeNowInd = chargeNow;
    } else {
      let reservationMessage = await new EVCStationReservationService().getReservationMessage();
      this.messageDisplayCount = localStorage.getItem('messageCount');
      if(reservationMessage.remarks == 'Yes' && this.selectedMarker.stationCategory.name == 'CPO' 
       && (this.messageDisplayCount == null || this.messageDisplayCount == 0)) {
        this.displayMessage(reservationMessage.description);
      }
     
      this.chargeNowInd = false;
    }
    this.hoursOfOperationsFormation();
    this.holidaysList = await new EVCStationService().stationHolidays(this.selectedMarker, new LocalStorage().user);
    this.stationImages = await new EVCStationService().stationImages(this.selectedMarker, new LocalStorage().user);
    this.opensAt = localStorage.getItem("opensAt");
    this.closesAt = localStorage.getItem("closesAt");
    this.portId = localStorage.getItem("portId");
    this.outputNumber = localStorage.getItem("outputNumber");
    this.serviceCall();
    // this.loaderTab = false;
  } catch(error) {
    this.loaderTab = false;
    let serviceError = migratedTryParseServiceError(error);
    new ToastUtils().presentToast(serviceError.description);
  }
  },
  updateProfile() {
    this.$router.push("/customer/profile")
  },
  addEV() {
    this.$router.push("/customer/evehicles/vehicle/R")
  },
  homePage() {
    let userRole = localStorage.getItem("user.roleId")
    if(userRole == 2) {
      this.$router.push("/customer/reservation")
    }
  },
  changeDateFormatWithoutTime(dateValue) {
    if(dateValue != null) {
      return moment(dateValue).format('DD/MMM/YYYY')
    }
  },
  navigatePreviousPage() {
    this.$router.go(-1)
  },
  getTitle(title) {
    let cusTitle = title.split(",")[0];
    return cusTitle;
  },
  afterslidesLoad(slides) {
    slides.startAutoplay();
  },
  
  async displayMessage(message) {
    return alertController.create({
      header: 'Reservation',
      message: message,
      backdropDismiss: false,
      buttons: [
        {
          text: 'Ok',
          role: 'Ok',
          handler: res => {
            this.messageDisplayCount = this.messageDisplayCount + 1;
            localStorage.setItem('messageCount', this.messageDisplayCount)
          }
        }
      ],
    }).then(res => {
      res.present();
    });      
  },
  slotBooking() {
    var confirmpageobj = {
      selectedMarker: this.selectedMarker,
      opensAt: this.opensAt,
      closesAt: this.closesAt,
      teleUrl: this.teleUrl
    };
    localStorage.setItem(
      "selectedChargerValue",
      JSON.stringify(this.selectedChargerValue)
    );
    localStorage.setItem("amountDetails", JSON.stringify(this.amountDetails));
    this.$router.push({ name: "selectVehicle" });
  },
  hoursOfOperationsFormation() {
    var week = [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun",
      "Public Holiday"
    ];
    this.selectedMarker.hoursOfOperations.map((data, index) => {
      if( index != 7 ){
      this.hoursOfOperations.push({
        // Migrated
        // openAt: this.hourFormat24(data.opensAt),
        // closeAt: this.hourFormat24(data.closesAt),
        openAt: this.getTimeInfo(data.opensAt),
        closeAt: this.getTimeInfo(data.closesAt),
        day: week[index]
      });
      }
    });
  },
  getTimeInfo(opensAt) {
    var beginningTime = moment(opensAt).format( "HH:mm");
    return beginningTime
    
  },
  hourFormat24(data) {
    
    var date = new Date(data);
    // console.log(date)
    var hour = date.getHours();
    var Min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
    return hour + ":" + Min;
  },
  async selecChargerUpdate(position, masterData, selectedValue, booleanValue) {
    // console.log(booleanValue)
    if (selectedValue.port.status.id === 'OC' && booleanValue != true) {
      // this.currentyOccupied();
      try {
        this.loaderTab = true;
        new EVCStationReservationService().getOccupiedMessage(selectedValue.setup.id).then((message) => {
          this.loaderTab = false;
          this.currentlyOccupied(message)
        }).catch((error) => {
          this.loaderTab = false;
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
        });
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    }

    if (!booleanValue) {
      this.selectedChargerValue = selectedValue;
      masterData.map((data, index) => {
        if (position != index) {
            data.isChecked = false;
        } else {
            data.isChecked = true;
        }
      });
    } else {
      this.selectedChargerValue = null;
      masterData.map((data, index) => {
        data.isChecked = false;
      });
    }
  },

  async currentlyOccupied(nextSLotInfo) {
    if(nextSLotInfo!=null) {
      return alertController.create({
        subHeader: nextSLotInfo.message,
        message: nextSLotInfo.availableDate,
        backdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            role: 'Ok',
            handler: res => {
              
            }
          }
        ],
      }).then(res => {
        res.present();
      }); 
    }
         
  },

  async serviceCall() {
    try {
      // this.loaderTab = true;
      new WalletService().summaryOfUser(new LocalStorage().user).then(data => {
        this.amountDetails = {
          totalBalance: data.totalBalance.toFixed(2),
          clearBalance: data.clearBalance.toFixed(2)
        };
      }).catch((error) => {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      });
      // this.loaderTab = true;
      let evStationData = await new EVCStationService().gunsOfChargersForSelectedStationByUser(
        this.selectedMarker,
        new LocalStorage().user
      );
      var stationArray = evStationData.gun;
      // this.thirdPartyInfo = evStationData.thirdPartyInfo.length > 0 ? evStationData.thirdPartyInfo : [];
      if(evStationData.thirdPartyInfo.length > 0) {
        this.thirdPartyInfo = evStationData.thirdPartyInfo;
        if(this.thirdPartyInfo[0].thirdPartyId != undefined) {
          this.thirdPartyInd = true;
        } else {
          this.displayCaptiveInfo = true;
        }
        
      } else {
        this.thirdPartyInfo = [];
        this.thirdPartyInd = false;
      }
      stationArray.map(data => {
          data["isChecked"] = false;
      });
      this.stationArray = stationArray;
      this.stationArrayLength = this.stationArray.length;
      this.showMore = this.stationArray.length > 2 ? true : false;
      this.dataFound = this.stationArray.length > 0 ? false : true;
      this.loaderTab = false;
    } catch (error) {
        this.loaderTab = false;
        // let serviceError = tryParseServiceError(error);
        // new ToastUtils().presentToast(serviceError ? serviceError : error);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
    }
  },
  googleMapApp() {
    if (
      /* if we're on iOS, open in Apple Maps */
      navigator.platform.indexOf("iPhone") != -1 ||
      navigator.platform.indexOf("iPod") != -1 ||
      navigator.platform.indexOf("iPad") != -1
    )
    window.open(
    "maps://maps.google.com/maps?daddr=" +
      this.selectedMarker.coordinate.latitude +
      "," +
      this.selectedMarker.coordinate.longitude +
      "&amp;ll="
    );
    /* else use Google */ else
    window.open(
    "https://maps.google.com/maps?daddr=" +
      this.selectedMarker.coordinate.latitude +
      "," +
      this.selectedMarker.coordinate.longitude +
      "&amp;ll="
    );
  }
}
})
</script>

<style scoped>
.btn-group {
  display: flex;
  gap: 10px;
}
.container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.card {
  width: 100%;
  max-width: 320px;
  padding: 25px 20px;
  border-radius: 16px;
  text-align: center;
  background: #ffffff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}


.card h3 {
  margin-bottom: 10px;
  font-weight: 600;
}

.card p {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

.btn-group ion-button {
  flex: 1;
}

.btn-res {
  --background: #21B24B;
  --border-radius: 12px;
}

.ios .ios-home{
color: white;
position: relative;
left:70%;
}

.page-wrapper,
.Charging-station-list {
background: #f4f5f9;
}

ion-content {
--background: #f4f5f9;
position: absolute;
--padding-bottom: 108px;
--padding-top: 54px;
}
.inactiveWrapper .cs-grid {
background: #0000000d;
pointer-events: none;
}
.inactiveWrapper .cs-grid-status-img {
display: none;
}
ion-footer {
position: fixed;
width: 100%;
bottom: 0;
}
.loc-img {
display: none;
}
.spinnerWrapper {
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
}
.appName {
color: green !important;
}
/* Title */
@media (max-width: 768px) {
.book-page {
  /* Status bar height on iOS 11.0 */
  top: constant(safe-area-inset-top);
  /* Status bar height on iOS 11+ */
  top: env(safe-area-inset-top);
}

.title-add-wrapper .add-wrapper .loc-img {
  margin-right: 13px !important;
}

.header-toolbar,
.mobile-header-toolbar {
  --background: #21b24b;
}

.mobile-header-toolbar {
  height: 56px;
  padding-top: 1px;
}

.mobile-header-toolbar ion-title {
  color: #fff;
}

.mobile-header-toolbar ion-buttons {
  color: #fff;
  --background: #fff;
}

.mobile-header-toolbar ion-back-button {
  color: #ffffff !important;
  margin-right: 13px;
}

.title-add-wrapper,
.time-detail-wrapper {
  padding-left: 18px !important;
  padding-right: 24px !important;
}

.Charging-station-list {
  padding-left: 9px !important;
  padding-right: 6px !important;
}

.paddingRight {
  padding-right: 0px !important;
}
}
.Charging-station-list {
position: relative;
padding-bottom: 39px;
}
.thirdparty-img {
width: 10rem;
}
@media (min-width: 992px) and (max-width: 1400px) {
.Charging-station-list .cs-grid .cs-grid-img {
  margin-right: 10px !important;
}
.Charging-station-list .cs-grid .cs-grid-cont {
  font-size: 12px !important;
}
}
@media (max-width: 768px) {
.Charging-station-list .cs-grid .cs-grid-status.unavailable {
  position: relative;
  margin-top: 30px;
  text-align: center;
  color: #d66c6c;
  background: transparent;
  font-size: 13px;
  /*font-weight: bold;*/
}

.Charging-station-list .cs-grid .cs-grid-status.occupied {
/* position: relative; */
/* margin-top: 30px; */
/* text-align: center; */
color: rgb(255, 140, 0);
background: transparent;
font-size: 13px;
/*font-weight: bold;*/
}
}
@media (min-width: 768px) {
.title-wrapper .price-tag {
  float: right;
}

.title-wrapper .price-tag {
  display: inline-block;
  margin-right: 20px;
  padding-top: 5px;
  padding-bottom: 7px;
}

.title-wrapper .price-tag p:first-child,
.title-wrapper .price-tag p:last-child,
.title-wrapper ion-title {
  font-family: "Roboto";
  font-size: 15px;
  color: #495057;
}

.title-wrapper ion-title {
  padding-top: 10px;
}

.title-wrapper .price-tag p:last-child {
  font-family: "Roboto Medium";
}
}

/* Title */

.fontRobotoBold {
font-family: "Roboto Bold";
}

.fontRobotoMedium {
font-family: "Roboto Medium";
}

.fontRobotoLight {
font-family: "Roboto light";
}

.fontRoboto {
font-family: "Roboto";
}

.paddingZero {
padding: 0;
}

.paddingGrid {
margin: -5px;
}

.clearFix {
clear: both;
}

.paddingGrid .listGrid {
  /* Margin top is modified for charger details is not displaying so here row top is occupied more space so modifing 17px to 10px */
/* margin-top: 17px; */
margin-top: 10px;
}
.title-add-wrapper {
min-height: 171px;
margin-top: 9px;
margin-bottom: 7px;
}

.time-detail-wrapper {
min-height: 222px;
padding-top: 19px;
}

.Charging-station-list {
min-height: 230px;
padding-top: 19px;
margin-bottom: 9px;
}

.Charging-station-list,
.title-add-wrapper,
.time-detail-wrapper {
padding-left: 25px;
padding-right: 35px;
background: #ffffff 0% 0% no-repeat padding-box;
border: 1px solid #0000001a;
opacity: 1;
}

.title-add-wrapper .add-wrapper {
margin-top: 13px;
}

.title-add-wrapper .title,
.Charging-station-list .title {
font-size: 15px;
color: #21315d;
opacity: 1;
}

.title-add-wrapper .title {
margin-bottom: 4px;
}

.title-add-wrapper .subtitle {
font-size: 14px;
color: #000000;
opacity: 0.5;
}

.title-add-wrapper .call-img {
width: 20px;
height: 20px;
}

.title-add-wrapper .add-wrapper .loc-img {
width: 21px;
height: 24px;
float: left;
margin-right: 22px;
}

.title-add-wrapper .add-wrapper .add-sec {
float: left;
}

.title-add-wrapper .add-wrapper .add-sec .address {
width: 167px;
max-height: 51px;
color: #202020;
opacity: 1;
font-size: 13px;
margin-bottom: 7px;
}

.title-add-wrapper .add-wrapper .add-sec .timeArea {
color: #313131;
opacity: 1;
font-size: 13px;
}

.title-add-wrapper .add-wrapper .add-sec .timeArea span {
color: #21b24b;
}

.title-add-wrapper .add-wrapper .distance {
color: #d66c6c;
opacity: 1;
margin-bottom: 9px;
font-size: 14px;
}

.title-add-wrapper .add-wrapper .map-img {
width: 45px;
height: 45px;
}

/* Charging-station-list */
.Charging-station-list .cs-grid {
/* Below hight is commented for charger details are not displaying so need to reduce the height from 110px to 90px */
  /* height: 110px; */
  height: 90px;
min-width: 300px;
border: 1px solid #0000001a;
border-radius: 12px;
opacity: 1;
padding: 11px 8px 13px 8px;
}
.Charging-station-list .cs-grid .cs-grid-img {
width: 44px;
height: 44px;
float: left;
margin-right: 20px;
}

.Charging-station-list .cs-grid .cs-grid-cont {
color: #202020;
font-size: 13px;
float: left;
}

.Charging-station-list .cs-grid .cs-grid-status-img {
float: right;
--border-radius: 50%;
--border: 1px solid #707070;
--background-checked: #21b24b;
--border-color-checked: #21b24b;
width: 26px;
height: 26px;
padding: 0px;
position: absolute;
right: 0;
top: 3px;
}

.Charging-station-list .cs-grid p {
text-align: left;
clear: both;
margin-bottom: 1px;
}

.Charging-station-list .cs-grid .cs-grid-status {
font-size: 14px;
text-align: right;
position: absolute;
bottom: 7px;
right: 0;
color: #21b24b;
}
.Charging-station-list .cs-grid .cs-grid-status.inactive {
color: #d66c6c;
background: transparent;
}
/* 08-09-2021 Below unavailable class is added by vinoth as per CR SCMT-CMS Charger Availability Status */

.Charging-station-list .cs-grid .cs-grid-status.unavailable {
position: relative;
margin-top: 30px;
text-align: center;
color: #d66c6c;
background: transparent;
/*font-size: 0.7rem;*/
/*font-weight: bold;*/
}

.Charging-station-list .cs-grid .cs-grid-status.occupied {
/* position: relative; */
/* margin-top: 30px; */
/* text-align: center; */
color: rgb(255, 140, 0);
background: transparent;
/*font-size: 0.7rem;*/
/*font-weight: bold;*/
}
/*  */
.show-more-link {
height: 17px;
font-size: 14px;
letter-spacing: 0;
color: #21315d;
opacity: 1;
width: 100%;
text-align: center;
margin-top: 39px;
}

.paddingRight {
padding-right: 20px;
}

.time-detail-wrapper .time-detail-list {
clear: both;
margin-bottom: 20px;
display: flex;
}

.time-detail-wrapper .time-detail-list .td-list-img {
float: left;
margin-right: 20px;
}

.time-detail-wrapper .time-detail-list .td-list-img.clock {
width: 24px;
height: 24px;
}

.time-detail-wrapper .time-detail-list .td-list-img.call {
width: 20px;
height: 20px;
}

.time-detail-wrapper .time-detail-list .td-list-img.envalop {
width: 20px;
height: 15px;
}

.time-detail-wrapper .time-detail-list .td-list-cont {
float: left;
}

.time-detail-wrapper .time-detail-list.time-details .td-list-cont {
color: #202020;
opacity: 1;
font-size: 13px;
}

.time-detail-wrapper .time-detail-list.time-details .td-list-cont p:first-child,
.time-detail-wrapper .time-detail-list .td-list-cont p {
font-size: 14px;
}

.time-detail-wrapper .time-detail-list .td-list-cont p:first-child span {
color: #21b24b;
}

.time-detail-wrapper .time-detail-list .td-list-cont.colorUP {
font-size: 14px;
color: #21315d;
}

.time-detail-wrapper .time-detail-list.time-details .td-list-cont p {
margin-bottom: 4px;
}

.time-detail-wrapper
.time-detail-list.time-details
.td-list-cont
p:first-child {
margin-bottom: 7px;
}

.time-detail-wrapper .time-detail-list.phone-num .td-list-cont p {
margin-bottom: 6px;
}

.next-btn {
height: 52px;
--background: #21b24b;
opacity: 1;
font-size: 17px;
color: #ffffff;
text-transform: uppercase;
margin: 0;
}

.next-btn img {
position: absolute;
right: 24px;
}
</style>